import React, { Component } from "react";

export default class PageSmallText extends Component {
  	
  	constructor(){
		super()
		this.state = {
			open: 		false,
			maxHeight: 0,
		}
		this.handleResize = this.handleResize.bind(this);
		this.handleToggle = this.handleToggle.bind(this);
	}
    
	componentDidMount() {
	  	window.addEventListener('resize', this.handleResize);
  	}
  	
  	componentWillUnmount() {
  		window.removeEventListener('resize', this.handleResize);
  	}
    
    handleToggle(_evt) {
	    _evt.preventDefault();  
	    if (this.state.open === true) {
	    	this.setState({ open : false });
	    } else {
		    this.setState({ open : true });
	    }
	    setTimeout(() => this.handleResize());
		setTimeout(() => this.handleResize());
    }
        
    handleResize() {
	  	if (this.accordionBody && this.state.open === true) {
	  		this.setState({maxHeight : this.accordionBodyInner.clientHeight});
  		} else {
	  		this.setState({maxHeight : 0});
  		}
  	}
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--text-space c-page__block--top-' + block.top_space + ' c-page__block--bottom-' + block.bottom_space + ' scope-' + block.background_colour}>
			    			    		
		    		<div className="c-page__block__inner">
			    			
		    			<div className="c-text-block">
		    				<div className="scope-text scope-text--small" dangerouslySetInnerHTML={{__html:block.text}}></div>
		    			</div>
		    			
		    			{block.more_text &&
			    			
			    			<div className={'c-text-block c-accordion ' + (this.state.open ? 'state-open' : "")}>																					
								<div className="c-accordion__body" ref={e => (this.accordionBody = e)} style={{maxHeight:this.state.maxHeight+'px'}}>
								
									<div className="c-accordion__body__inner" ref={e => (this.accordionBodyInner = e)}>
																	
										<div className="scope-text scope-text--small" dangerouslySetInnerHTML={ {__html:block.more_text}}></div>
																			
									</div>
								</div>
								<div className="c-buttons c-buttons--large-top-space">
									{this.state.open &&
										<a href="#" className="c-buttons__button" onClick={this.handleToggle}>Read Less</a>
									}
									{!this.state.open &&
										<a href="#" className="c-buttons__button" onClick={this.handleToggle}>Read More</a>
									}
								</div>
							</div>
						    
			    			
		    			}
																    			
		    		</div>
			    					    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
